import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  CreateManagedSyncMutation,
  CreateManagedSyncMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const createManagedSyncQuery = graphql(`
  mutation createManagedSync($req: CreateManagedSyncRequest!) {
    createManagedSync(CreateManagedSyncRequest: $req) {
      id
      userId
      integration
      pipeline
      projectId
      status
    }
  }
`);

export function useCreateManagedSync(
  options?: UseMutationOptions<
    CreateManagedSyncMutation,
    unknown,
    CreateManagedSyncMutationVariables,
    unknown
  >,
) {
  return useGraphQlMutation(createManagedSyncQuery, { ...options });
}
